<div class="map-list-wrapper" [class.showing-map]="!hideMap">
  @if (!hideMap) {
  <div class="map-wrapper hide-small-screen">
    <article [ngClass]="theme.getThemeClass()" class="mapHeader">
      <div>
        <p id="lastExpanded">{{ lastExpanded }}</p>
        <p id="lastExpandedAddress">{{ address | translate }}</p>
      </div>
      <p
        (click)="closeMap()"
        id="closeMap"
        title="{{ 'iotModalButtonClose' | translate }}"
      >
        <i class="fa fa-times" aria-hidden="true"></i>
      </p>
    </article>
    <div #mapContainer id="mapDesktop" class="mapDesktop"></div>
  </div>
  }

  <div [ngClass]="theme.getThemeClass()" class="table-container width100">
    @if (view.loading) {
    <div class="table-loading-placeholder">
      <div class="loader"></div>
    </div>
    } @else {
    <article class="table-responsive minMarginBotton">
      <table class="table table-hover">
        <thead>
          <tr>
            <th [ngClass]="theme.getThemeClass()">
              {{ "iotTabHeaderDevice" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "version" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "_client" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "_distributor" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "binModel" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "binHeader" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "filled" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "volume" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "market" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "binListViewUsage" | translate }}
            </th>
            <!-- <th [ngClass]="theme.getThemeClass()">
              {{ "iotTabHeaderStatus" | translate }}
            </th> -->
            <th [ngClass]="theme.getThemeClass()">
              {{ "iotTabHeaderLastActivity" | translate }}
            </th>
            <th [ngClass]="theme.getThemeClass()">
              {{ "iotTabHeaderResources" | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          @for (deviceRow of filteredDevices(); track deviceRow.thingName) {
          <tr>
            <td [ngClass]="theme.getThemeClass()">{{ deviceRow.thingName }}</td>
            <td [ngClass]="theme.getThemeClass()">{{ deviceRow.dat.fdv }}</td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.bin?.client ?? "N/A" }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.bin?.legal_name ?? "N/A" }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.bin?.bin_model_number ?? "N/A" }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{ deviceRow.bin?.bin_name ?? "N/A" }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{
                calculateFillPercentage(
                  deviceRow.bin?.bin_height,
                  deviceRow.dat.dst
                )
              }}%
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{
                deviceRow.bin?.bin_height ? deviceRow.bin?.total_volume : "N/A"
              }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{
                binService.getBinMarket(deviceRow.bin?.market_segment ?? "")
                  | translate
              }}
            </td>
            <td [ngClass]="theme.getThemeClass()">
              {{
                binService.getBinUsage(deviceRow.bin?.bin_usage ?? "")
                  | translate
              }}
            </td>
            <!-- <td [ngClass]="theme.getThemeClass()">
              {{ verifyStatus(deviceRow.thingName) | translate }}
            </td> -->
            <td [ngClass]="theme.getThemeClass()">{{ deviceRow.date }}</td>
            <td [ngClass]="theme.getThemeClass()">
              <div class="divButton">
                <!-- Show the map with pin of the device position -->
                <a href="javascript:void(0)" (click)="showMap(deviceRow)">
                  <img
                    [title]="'showLocation' | translate"
                    class="iconMap"
                    src="./assets/mappoint.png"
                    alt="map icon"
                    height="20"
                    width="20"
                  />
                </a>
                <!-- Show device configs modal -->
                <a
                  href="javascript:void(0)"
                  (click)="this.iotService.showConfig(deviceRow.thingName)"
                  [class.disabled]="this.iotService.cognitoService.userType !== 'muirwood'"
                >
                  <img
                    [title]="'iotModalViewConfig' | translate"
                    class="iconParam"
                    src="./assets/settings.png"
                    alt="icon of param"
                    height="20"
                    width="20"
                    style="color: gray"
                  />
                </a>
                <!-- Show device notes modal -->
                <a
                  href="javascript:void(0)"
                  (click)="
                    this.showDeviceNotes(deviceRow.thingName);
                    this.modal.showNotes(deviceRow.thingName)
                  "
                >
                  <i class="fa-solid fa-file-pen note-icon"></i>
                </a>
                <!-- Show device shadow modal -->
                <a
                  href="javascript:void(0)"
                  (click)="
                    this.modal.showShadow(
                      this.iotService.getDeviceShadow(deviceRow.thingName),
                      deviceRow.thingName
                    )
                  "
                >
                  <img
                    [title]="'shadow' | translate"
                    class="iconParam"
                    src="./assets/json-icon.png"
                    alt="icon of json"
                    height="20"
                    width="20"
                    style="color: gray"
                  />
                </a>
                <!-- Download device certificate -->
                <a
                  href="javascript:void(0)"
                  (click)="this.getCertificateFolderUrl(deviceRow.thingName)"
                >
                  <img
                    [title]="'generateCertificate' | translate"
                    class="iconCert"
                    src="./assets/grey-certificate-48.png"
                    alt="icon of certificate"
                    height="25"
                    width="25"
                    style="color: gray"
                  />
                </a>
                <!-- Show device association modal -->
                <a
                  href="javascript:void(0)"
                  (click)="this.showRelation(deviceRow.thingName)"
                >
                  <img
                    [title]="'deviceRelationship' | translate"
                    class="iconCert"
                    src="./assets/relationship.png"
                    alt="icon of relationship"
                    height="25"
                    width="25"
                    style="color: gray"
                  />
                </a>
                <!-- Send user to device statistic page -->
                <a (click)="setNavToDeviceStat(deviceRow.thingName)">
                  <img
                    [title]="'showReports' | translate"
                    class="iconStat"
                    src="./assets/bar-chart-48.png"
                    alt="icon of a chart"
                    height="25"
                    width="25"
                    style="color: gray"
                  />
                </a>
                <!-- Show delete device modal -->
                <a
                  href="javascript:void(0)"
                  (click)="
                    this.modal.showDeviceModal = true;
                    this.iotService.ShowDeleteThingModal(deviceRow.thingName)
                  "
                >
                  <i class="fa-solid fa-trash delete-device"></i>
                </a>
                <!-- Show modal to reset device and his data to initial values -->
                <a
                  href="javascript:void(0)"
                  (click)="initializeDeviceForProduction(deviceRow.thingName)"
                >
                  <i
                    [title]="'initializeDeviceIcon' | translate"
                    class="fa-solid fa-arrows-rotate refresh-device"
                  ></i>
                </a>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </article>
    }
  </div>
</div>
